import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Button} from "react-bootstrap";
import React from "react";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function InfoDialog(props) {

    return (
        <Dialog
            open={props.openDialog}
            onClose={props.handleCloseDialog}
            aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title" style={{border:'1px solid #dee2e6'}}>
                <div>
                    <p style={{ verticalAlign: 'middle', float: 'left',fontSize: 30,margin: 0,paddingTop: 8}}>{'Bilgi'}</p>
                    <InfoOutlinedIcon style={{fontSize: 60, float: 'right'}}/>
                </div>
            </DialogTitle>
            <DialogContent style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <DialogContentText>
                    {props.dialogContentText}
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{borderTop: '1px solid #dee2e6'}}>
                <Button onClick={props.handleAcceptDialog} variant="info" autoFocus>
                    Tamam
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default InfoDialog;